import { connect } from "react-redux";
import CurrencyFormatter from "currency-formatter";
import InlineLoading from "../../../../../components/Loading/Loading";
import MonthlyProfitAndLoss from "../../../../../models/financials/MonthlyProfitAndLoss";
import { primary } from "../../../../../assets/colorPallet";

function MonthlyProfitAndLossConsolidation({
  currentCompanyMonthlyProfitAndLoss,
}) {
  if (!(currentCompanyMonthlyProfitAndLoss instanceof MonthlyProfitAndLoss)) {
    return <InlineLoading />;
  }
  
  return (
    <>
      <div className="flex items-center w-full mt-10">
        <div
          style={{ backgroundColor: primary }}
          className="absolute left-0 w-full h-12 bg-gradient-to-r from-transparent z-10 pointer-events-none"
        ></div>
        <div className="z-20" style={{ minWidth: "20em" }}></div>
        {currentCompanyMonthlyProfitAndLoss?.datesFormatted.map((date) => (
          <div className="z-20 w-40 font-semibold" style={{ minWidth: "10em" }}>
            <label className="text-white">{date}</label>
          </div>
        ))}
      </div>

      <div className="flex items-center pt-4">
        <div
          className="whitespace-nowrap flex items-center pt-4"
          style={{ minWidth: "20em" }}
        >
          <label className="font-semibold">Total Sales</label>
        </div>
        <div className="flex pt-4">
          {currentCompanyMonthlyProfitAndLoss?.totalSales?.map((item) => (
            <div className="flex items-center" style={{ minWidth: "10em" }}>
              <label className="font-semibold">
                {CurrencyFormatter.format(item?.value, { code: "USD" })}
              </label>
            </div>
          ))}
        </div>
      </div>

      <div className="flex items-center pt-4">
        <div
          className="whitespace-nowrap flex items-center pt-4"
          style={{ minWidth: "20em" }}
        >
          <label>(Total Cost of Goods)</label>
        </div>
        <div className="flex pt-4">
          {currentCompanyMonthlyProfitAndLoss?.totalCostOfSales?.map((item) => (
            <div className="flex items-center" style={{ minWidth: "10em" }}>
              <label>
                ({CurrencyFormatter.format(item?.value, { code: "USD" })})
              </label>
            </div>
          ))}
        </div>
      </div>

      <div className="pt-4">
        <div className="flex items-center">
          <div
            className="whitespace-nowrap flex items-center border-t pt-2"
            style={{ minWidth: "20em" }}
          >
            <label className="font-semibold">Gross Profit</label>
          </div>
          <div className="flex pt-2 border-t">
            {currentCompanyMonthlyProfitAndLoss?.totalGrossProfits?.map(
              (item) => (
                <div className="flex items-center" style={{ minWidth: "10em" }}>
                  <label className="font-semibold">
                    {CurrencyFormatter.format(item?.value, { code: "USD" })}
                  </label>
                </div>
              )
            )}
          </div>
        </div>
        <div className="flex items-center">
          <div
            className="whitespace-nowrap flex items-center pt-1"
            style={{ minWidth: "20em" }}
          >
            <label className="text-xs">Gross Profit Margin</label>
          </div>
          <div className="flex pt-1">
            {currentCompanyMonthlyProfitAndLoss?.grossProfitMargins?.map(
              (item) => (
                <div className="flex items-center" style={{ minWidth: "10em" }}>
                  <label className="text-xs">
                    {CurrencyFormatter.format(item?.value, { code: "" })}%
                  </label>
                </div>
              )
            )}
          </div>
        </div>
      </div>

      <div className="pt-4">
        <div className="flex items-center">
          <div
            className="whitespace-nowrap flex items-center pt-4"
            style={{ minWidth: "20em" }}
          >
            <label>(Total Operating Expenses)</label>
          </div>
          <div className="flex pt-4">
            {currentCompanyMonthlyProfitAndLoss?.totalOperatingExpenses?.map(
              (item) => (
                <div className="flex items-center" style={{ minWidth: "10em" }}>
                  <label>
                    ({CurrencyFormatter.format(item?.value, { code: "USD" })})
                  </label>
                </div>
              )
            )}
          </div>
        </div>
        <div className="flex items-center">
          <div
            className="whitespace-nowrap flex items-center pt-1"
            style={{ minWidth: "20em" }}
          >
            <label className="text-xs">Operating Expenses Margin</label>
          </div>
          <div className="flex pt-1">
            {currentCompanyMonthlyProfitAndLoss?.operExpenseMargins?.map(
              (item) => (
                <div className="flex items-center" style={{ minWidth: "10em" }}>
                  <label className="text-xs">
                    {CurrencyFormatter.format(item?.value, { code: "" })}%
                  </label>
                </div>
              )
            )}
          </div>
        </div>
      </div>

      <div className="pt-4">
        <div className="flex items-center">
          <div
            className="whitespace-nowrap flex items-center border-t pt-2"
            style={{ minWidth: "20em" }}
          >
            <label className="font-semibold">Operating Income</label>
          </div>
          <div className="flex pt-2 border-t">
            {currentCompanyMonthlyProfitAndLoss?.totalOperatingIncome?.map(
              (item) => (
                <div className="flex items-center" style={{ minWidth: "10em" }}>
                  <label className="font-semibold">
                    {CurrencyFormatter.format(item?.value, { code: "USD" })}
                  </label>
                </div>
              )
            )}
          </div>
        </div>
        <div className="flex items-center">
          <div
            className="whitespace-nowrap flex items-center pt-1"
            style={{ minWidth: "20em" }}
          >
            <label className="text-xs">Operating Income Margin</label>
          </div>
          <div className="flex pt-1">
            {currentCompanyMonthlyProfitAndLoss?.operIncomeMargins?.map(
              (item) => (
                <div className="flex items-center" style={{ minWidth: "10em" }}>
                  <label className="text-xs">
                    {CurrencyFormatter.format(item?.value, { code: "" })}%
                  </label>
                </div>
              )
            )}
          </div>
        </div>
      </div>

      <div className="pt-4">
        <div className="flex items-center">
          <div
            className="whitespace-nowrap flex items-center pt-4"
            style={{ minWidth: "20em" }}
          >
            <label>Total Other Income</label>
          </div>
          <div className="flex pt-4">
            {currentCompanyMonthlyProfitAndLoss?.totalOtherIncomes?.map(
              (item) => (
                <div className="flex items-center" style={{ minWidth: "10em" }}>
                  <label>
                    {CurrencyFormatter.format(item?.value, { code: "USD" })}
                  </label>
                </div>
              )
            )}
          </div>
        </div>
        <div className="flex items-center">
          <div
            className="whitespace-nowrap flex items-center pt-1"
            style={{ minWidth: "20em" }}
          >
            <label className="text-xs">Other Income Margin</label>
          </div>
          <div className="flex pt-1">
            {currentCompanyMonthlyProfitAndLoss?.otherIncomeMargins?.map(
              (item) => (
                <div className="flex items-center" style={{ minWidth: "10em" }}>
                  <label className="text-xs">
                    {CurrencyFormatter.format(item?.value, { code: "" })}%
                  </label>
                </div>
              )
            )}
          </div>
        </div>
      </div>

      <div className="pt-4">
        <div className="flex items-center">
          <div
            className="whitespace-nowrap flex items-center pt-1"
            style={{ minWidth: "20em" }}
          >
            <label>(Total Other Expenses)</label>
          </div>
          <div className="flex pt-1">
            {currentCompanyMonthlyProfitAndLoss?.totalOtherExpenses?.map(
              (item) => (
                <div className="flex items-center" style={{ minWidth: "10em" }}>
                  <label>
                    ({CurrencyFormatter.format(item?.value, { code: "USD" })})
                  </label>
                </div>
              )
            )}
          </div>
        </div>
        <div className="flex items-center">
          <div
            className="whitespace-nowrap flex items-center pt-1"
            style={{ minWidth: "20em" }}
          >
            <label className="text-xs">Other Expenses Margin</label>
          </div>
          <div className="flex pt-1">
            {currentCompanyMonthlyProfitAndLoss?.otherExpensesMargins?.map(
              (item) => (
                <div className="flex items-center" style={{ minWidth: "10em" }}>
                  <label className="text-xs">
                    {CurrencyFormatter.format(item?.value, { code: "" })}%
                  </label>
                </div>
              )
            )}
          </div>
        </div>
      </div>

      <div className="pt-4">
        <div className="flex items-center">
          <div
            className="whitespace-nowrap flex items-center border-t pt-2"
            style={{ minWidth: "20em" }}
          >
            <label className="font-semibold">
              Earnings Before Income Taxes
            </label>
          </div>
          <div className="flex pt-2 border-t">
            {currentCompanyMonthlyProfitAndLoss?.earningsBeforeIncomeTaxes?.map(
              (item) => (
                <div className="flex items-center" style={{ minWidth: "10em" }}>
                  <label className="font-semibold">
                    {CurrencyFormatter.format(item?.value, { code: "USD" })}
                  </label>
                </div>
              )
            )}
          </div>
        </div>
        <div className="flex items-center">
          <div
            className="whitespace-nowrap flex items-center pt-1"
            style={{ minWidth: "20em" }}
          >
            <label className="text-xs">EBIT Margin</label>
          </div>
          <div className="flex pt-1">
            {currentCompanyMonthlyProfitAndLoss?.EBITMargins?.map((item) => (
              <div className="flex items-center" style={{ minWidth: "10em" }}>
                <label className="text-xs">
                  {CurrencyFormatter.format(item?.value, { code: "" })}%
                </label>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="pt-4">
        <div className="flex items-center">
          <div
            className="whitespace-nowrap flex items-center pt-4"
            style={{ minWidth: "20em" }}
          >
            <label>Interest Income</label>
          </div>
          <div className="flex pt-4">
            {currentCompanyMonthlyProfitAndLoss?.totalInterestIncome?.map(
              (item) => (
                <div className="flex items-center" style={{ minWidth: "10em" }}>
                  <label>
                    {CurrencyFormatter.format(item?.value, { code: "USD" })}
                  </label>
                </div>
              )
            )}
          </div>
        </div>
        <div className="flex items-center">
          <div
            className="whitespace-nowrap flex items-center pt-1"
            style={{ minWidth: "20em" }}
          >
            <label className="text-xs">Interest Income Margin</label>
          </div>
          <div className="flex pt-1">
            {currentCompanyMonthlyProfitAndLoss?.interestIncomeMargins?.map(
              (item) => (
                <div className="flex items-center" style={{ minWidth: "10em" }}>
                  <label className="text-xs">
                    {CurrencyFormatter.format(item?.value, { code: "" })}%
                  </label>
                </div>
              )
            )}
          </div>
        </div>
      </div>

      <div className="pt-4">
        <div className="flex items-center">
          <div
            className="whitespace-nowrap flex items-center pt-1"
            style={{ minWidth: "20em" }}
          >
            <label>(Interest Expense)</label>
          </div>
          <div className="flex pt-1">
            {currentCompanyMonthlyProfitAndLoss?.totalInterestExpense?.map(
              (item) => (
                <div className="flex items-center" style={{ minWidth: "10em" }}>
                  <label>
                    ({CurrencyFormatter.format(item?.value, { code: "USD" })})
                  </label>
                </div>
              )
            )}
          </div>
        </div>
        <div className="flex items-center">
          <div
            className="whitespace-nowrap flex items-center pt-1"
            style={{ minWidth: "20em" }}
          >
            <label className="text-xs">Interest Expense Margin</label>
          </div>
          <div className="flex pt-1">
            {currentCompanyMonthlyProfitAndLoss?.interestExpenseMargins?.map(
              (item) => (
                <div className="flex items-center" style={{ minWidth: "10em" }}>
                  <label className="text-xs">
                    {CurrencyFormatter.format(item?.value, { code: "" })}%
                  </label>
                </div>
              )
            )}
          </div>
        </div>
      </div>

      <div className="pt-4">
        <div className="flex items-center">
          <div
            className="whitespace-nowrap flex items-center border-t pt-2"
            style={{ minWidth: "20em" }}
          >
            <label className="font-semibold">Pre-Tax Net Profit</label>
          </div>
          <div className="flex pt-2 border-t">
            {currentCompanyMonthlyProfitAndLoss?.totalPreTaxNetProfits?.map(
              (item) => (
                <div className="flex items-center" style={{ minWidth: "10em" }}>
                  <label className="font-semibold">
                    {CurrencyFormatter.format(item?.value, { code: "USD" })}
                  </label>
                </div>
              )
            )}
          </div>
        </div>
        <div className="flex items-center">
          <div
            className="whitespace-nowrap flex items-center pt-1"
            style={{ minWidth: "20em" }}
          >
            <label className="text-xs">EBT Margin</label>
          </div>
          <div className="flex pt-1">
            {currentCompanyMonthlyProfitAndLoss?.EBTMargins?.map((item) => (
              <div className="flex items-center" style={{ minWidth: "10em" }}>
                <label className="text-xs">
                  {CurrencyFormatter.format(item?.value, { code: "" })}%
                </label>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="pt-4">
        <div className="flex items-center">
          <div
            className="whitespace-nowrap flex items-center pt-4"
            style={{ minWidth: "20em" }}
          >
            <label>(Income Tax)</label>
          </div>
          <div className="flex pt-4">
            {currentCompanyMonthlyProfitAndLoss?.totalIncomeTax?.map((item) => (
              <div className="flex items-center" style={{ minWidth: "10em" }}>
                <label>
                  ({CurrencyFormatter.format(item?.value, { code: "USD" })})
                </label>
              </div>
            ))}
          </div>
        </div>
        <div className="flex items-center">
          <div
            className="whitespace-nowrap flex items-center pt-1"
            style={{ minWidth: "20em" }}
          >
            <label className="text-xs">Income Tax Margin</label>
          </div>
          <div className="flex pt-1">
            {currentCompanyMonthlyProfitAndLoss?.incomeTaxMargins?.map(
              (item) => (
                <div className="flex items-center" style={{ minWidth: "10em" }}>
                  <label className="text-xs">
                    {CurrencyFormatter.format(item?.value, { code: "" })}%
                  </label>
                </div>
              )
            )}
          </div>
        </div>
      </div>

      <div className="pt-4">
        <div className="flex items-center">
          <div
            className="whitespace-nowrap flex items-center border-t pt-2"
            style={{ minWidth: "20em" }}
          >
            <label className="font-semibold">After-Tax Net Profit</label>
          </div>
          <div className="flex pt-2 border-t">
            {currentCompanyMonthlyProfitAndLoss?.totalAfterTaxNetProfits?.map(
              (item) => (
                <div className="flex items-center" style={{ minWidth: "10em" }}>
                  <label className="font-semibold">
                    {CurrencyFormatter.format(item?.value, { code: "USD" })}
                  </label>
                </div>
              )
            )}
          </div>
        </div>
        <div className="flex items-center">
          <div
            className="whitespace-nowrap flex items-center pt-1"
            style={{ minWidth: "20em" }}
          >
            <label className="text-xs">Net Profit Margin</label>
          </div>
          <div className="flex pt-1">
            {currentCompanyMonthlyProfitAndLoss?.netProfitMargins?.map(
              (item) => (
                <div className="flex items-center" style={{ minWidth: "10em" }}>
                  <label className="text-xs">
                    {CurrencyFormatter.format(item?.value, { code: "" })}%
                  </label>
                </div>
              )
            )}
          </div>
        </div>
      </div>
    </>
  );
}

const mapStateToProps = (state) => ({
  currentCompanyMonthlyProfitAndLoss:
    state.financials.currentCompanyMonthlyProfitAndLoss,
});

export default connect(mapStateToProps)(MonthlyProfitAndLossConsolidation);
